import React, { useMemo } from "react";
import CanvasJSReact from "../../../assets/canvasjs.react";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

/**
 * @param {{
 *   courseRegistrationList: Array<{
 *     course: string,
 *     isAlternate?: boolean,
 *     passed?: boolean
 *   }>,
 *   courseList: Array<{ _id:string, code:string }>
 * }} props
 */
const CourseSuccessChart = ({ courseRegistrationList = [], courseList = [] }) => {
    // mapa kurzId -> kód kurzu (pro popisky)
    const courseCodeMap = useMemo(() => {
        const m = new Map();
        for (const c of courseList) m.set(c._id, c.code);
        return m;
    }, [courseList]);

    // agregace jen pro ne-náhradníky (isAlternate === false)
    const { passedPoints, failedPoints, totalCount } = useMemo(() => {
        const byCourse = new Map(); // courseId -> {passed:0, failed:0}

        for (const cr of courseRegistrationList) {
            if (cr.isAlternate !== false) continue; // bereme jen ne-náhradníky
            const cid = cr.course._id;
            if (!cid) continue;
            if (!byCourse.has(cid)) byCourse.set(cid, { passed: 0, failed: 0 });
            const entry = byCourse.get(cid);
            if (cr.passed === true) entry.passed += 1;
            else entry.failed += 1; // vše ostatní počítáme jako "neprošel"
        }

        // převod do CanvasJS dataPoints
        const passedPoints = [];
        const failedPoints = [];
        let total = 0;

        // seřadíme dle kódu kurzu pro přehlednost
        const sorted = Array.from(byCourse.entries()).sort((a, b) => {
            const ca = courseCodeMap.get(a[0]) || "";
            const cb = courseCodeMap.get(b[0]) || "";
            return ca.localeCompare(cb, "cs");
        });

        for (const [cid, agg] of sorted) {
            const label = courseCodeMap.get(cid) || cid;
            passedPoints.push({ y: agg.passed, label });
            failedPoints.push({ y: agg.failed, label });
            total += agg.passed + agg.failed;
        }

        return { passedPoints, failedPoints, totalCount: total };
    }, [courseRegistrationList, courseCodeMap]);

    if (!passedPoints.length && !failedPoints.length) {
        return (
            <div className="dashboard-charts-occupancy-chart">
                <h3>Úspěšnost kurzů</h3>
                <div>Žádná data k zobrazení</div>
            </div>
        );
    }

    const options = {
        theme: "light2",
        title: {
            text: `Úspěšnost kurzů (ne-náhradníci, ∑ ${totalCount})`
        },
        axisY: {
            includeZero: true,
            title: "Počet studentů",
            interval: 1,
        },
        axisX: {
            labelAngle: -30,
            labelFontSize: 12,
            interval: 1,
            title: "Kurzy"
        },
        toolTip: { shared: true },
        legend: { cursor: "pointer" },
        data: [
            {
                type: "area",
                name: "Prošli",
                showInLegend: true,
                color: "#16a34a",
                dataPoints: passedPoints
            },
            {
                type: "area",
                name: "Neprošli",
                showInLegend: true,
                color: "#dc2626",
                dataPoints: failedPoints
            }
        ]
    };

    return (
        <div className="dashboard-charts-occupancy-chart">
            <CanvasJSChart options={options} />
        </div>
    );
};

export default CourseSuccessChart;
